import ApiClient from "@/api/v1/base";
import eventBus from "@/shared/event-bus";
import roleSwitcher from "@/shared/navbar-v2/role-switcher";

const ROLE_BUYER = 'C';
const ROLE_DESIGNER = 'D';
const ROLE_BOTH = 'B';

class InitDataResolver
{
    initDataPromise = null;

    requestInitData() {
        const api = new ApiClient();

        return api._get('/api/v1/init-data').then((response) => {
            const initData = this.populate(response.data);
            this.saveData(initData);

            return initData;
        });
    }

    populate(initData)
    {
        let role = initData.user?.role;

        if (initData.user?.role === ROLE_BOTH) {
            role = roleSwitcher.getRole();
        }

        initData.is_buyer = role === ROLE_BUYER;
        initData.is_designer = role === ROLE_DESIGNER;

        return initData;
    }

    saveData(initData) {
        global.initData = initData;
        global.initDataInvalidated = false;

        this.onResolved(global.initData);
    }

    resolve() {
        if (global.initDataInvalidated) {
            global.initDataInvalidated = false;
            this.initDataPromise = this.requestInitData();
            return this.initDataPromise;
        }

        if (typeof global.initData !== 'undefined') {
            return new Promise(resolve => {
                resolve(global.initData);
                this.onResolved(global.initData);
            });
        }

        if (this.initDataPromise === null) {
            this.initDataPromise = this.requestInitData();
        }

        return this.initDataPromise;
    }

    onResolved(initData) {
        const event = new CustomEvent('initDataResolved', {initData: initData});
        document.dispatchEvent(event);
    }

    reload()
    {
        global.initDataInvalidated = true;

        return this.resolve();
    }
}

eventBus.on('init_data_changed', () => {
    global.initDataInvalidated = true;
})

const initDataResolver = new InitDataResolver();

const resolveInitData = function(force) {
    return force ? initDataResolver.reload() : initDataResolver.resolve();
}

export default resolveInitData;
